import { differentials } from '@/mocks/homeData';

export default function WhyChooseUs() {
  return (
    <section id="diferenciais" className="py-12 md:py-16 px-4 md:px-8 bg-background-100">
      <div>
        <h2 className="text-center text-lg md:text-xl font-bold text-secondary-900 tracking-wide mb-10 md:mb-12">
          POR QUE ESCOLHER A BERTONCELLO NEGÓCIOS IMOBILIÁRIOS BNI?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
          {differentials.map((item) => (
            <div key={item.id} className="text-center group">
              {/* Icon */}
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100/70 group-hover:bg-primary-200/70 transition-colors">
                <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center text-primary-500">
                  <i className={`${item.icon} text-xl md:text-2xl`}></i>
                </span>
              </div>

              {/* Title */}
              <h3 className="text-xs md:text-sm font-bold text-secondary-900 mb-2 tracking-wide leading-tight">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-xs text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}